module.exports = __webpack_public_path__ + "static/media/ChicagoBooth.31831156.svg";